import { CashUpReportDto } from './cash-up-report.dto';
import { IsDefined, IsNotEmptyObject, IsNumber, IsOptional, MaxLength, ValidateNested } from 'class-validator';

export class CashUpReportCreateDto {
  @IsDefined()
  @IsNumber()
  merchantId: number;

  @IsOptional()
  @MaxLength(255)
  note?: string;

  @IsDefined()
  @IsNotEmptyObject()
  @ValidateNested()
  report: CashUpReportDto;
}
